import styled from 'styled-components';

export const TimeRowContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-items: center;
  margin-bottom: 20px;
  gap: 12px;
`;
